module.exports = __webpack_public_path__ + "media/images/homes/retail-9d3ce46aa42cc5449c6e71c01cee06c5.png";